/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 挿管器具
 */
export type IntubationDevice =
  (typeof IntubationDevice)[keyof typeof IntubationDevice];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntubationDevice = {
  MANUAL: 'MANUAL',
  NASAL_AIRWAY: 'NASAL_AIRWAY',
  LM: 'LM',
  LT: 'LT',
  TRACHEAL_INTUBATION: 'TRACHEAL_INTUBATION',
  VIDEO_LARYNGOSCOPE: 'VIDEO_LARYNGOSCOPE',
  FOREIGN_BODY_REMOVAL: 'FOREIGN_BODY_REMOVAL',
  OTHER: 'OTHER',
} as const;
